// @flow

import React, { PureComponent } from "react";
import Icon from "@fdr/static-ui/Icons";
import { noop } from "lodash";
import type { UnaryFn } from "@tvg/types/Functional";
import { arrowLeft, arrowRight } from "@fdr/static-ui/Icons/icons";
import buildColor from "@fdr/static-ui/ColorPalette";

import { Wrapper, ArrowButton } from "./styled-components";

type Props = {
  onBackPageLink: string,
  /**
   * Callback to go forward in pagination
   */
  onForwardPageLink: string,
  /**
   * Classname to style the component
   */
  className: string,
  /**
   * QA Label
   */
  qaLabel: string,
  /**
   * disable back button
   */
  isBackDisabled: boolean,
  /**
   * disable forward button
   */
  isForwardDisabled: boolean,
  /**
   * execute conde on click event
   */
  onEventClick: UnaryFn<string, void>,
  /**
   * Make the button stay near
   */
  isNear: boolean,
  /**
   * Make the button with night mode style
   */
  isNightMode: boolean
};

export default class ArrowPagination extends PureComponent<Props> {
  static defaultProps = {
    onBackPage: "",
    onForwardPage: "",
    className: "",
    qaLabel: "arrowPagination",
    isBackDisabled: false,
    isForwardDisabled: false,
    onEventClick: noop,
    isNear: false,
    isNightMode: false
  };

  ARROW_SIZE = 20;

  render() {
    const onClickArrowBtn = (
      e: Event,
      action: "PREVIOUS_RACE" | "NEXT_RACE"
    ) => {
      if (
        (action === "PREVIOUS_RACE" && this.props.isBackDisabled) ||
        (action === "NEXT_RACE" && this.props.isForwardDisabled)
      ) {
        e.preventDefault();
        e.stopPropagation();
      } else {
        this.props.onEventClick(action);
      }
    };

    const getArrowColor = (isDisabled: boolean) => {
      if (isDisabled) {
        return buildColor("grey", "D3");
      }

      return this.props.isNightMode ? buildColor("white") : buildColor("blue");
    };

    return (
      <Wrapper
        className={this.props.className}
        data-qa-label={this.props.qaLabel}
        $isNear={this.props.isNear}
      >
        <ArrowButton
          to={this.props.onBackPageLink}
          onClick={(e: Event) => onClickArrowBtn(e, "PREVIOUS_RACE")}
          disabled={this.props.isBackDisabled}
          data-qa-label="pagination-previousButton"
          $isNear={this.props.isNear}
          $isNightMode={this.props.isNightMode}
        >
          <Icon
            icon={arrowLeft}
            color={getArrowColor(this.props.isBackDisabled)}
            size={this.ARROW_SIZE}
          />
        </ArrowButton>
        <ArrowButton
          to={this.props.onForwardPageLink}
          onClick={(e: Event) => onClickArrowBtn(e, "NEXT_RACE")}
          disabled={this.props.isForwardDisabled}
          data-qa-label="pagination-forwardButton"
          $isNear={this.props.isNear}
          $isNightMode={this.props.isNightMode}
        >
          <Icon
            icon={arrowRight}
            color={getArrowColor(this.props.isForwardDisabled)}
            size={this.ARROW_SIZE}
          />
        </ArrowButton>
      </Wrapper>
    );
  }
}
